module.exports = __webpack_public_path__ + "static/img/question@3x_banner@3x.dc67e7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/question@3x_banner@3x.png
// module id = apjR
// module chunks = 1